export const isNumeric = (n) => {
    return !!([!0, !0, !0, !0, !0, !0, !0, !0, !0, !0][n])
}